import { apiGet, apiPost } from "../../utils"

export function getAdminProfileAPI() {
    return apiGet('/api/getAdminProfileAdmin')
}

export function applyLeaveAPI(data) {
    return apiPost('/api/applyLeaveAdmin', data)
}

export function getLeaveCalendarAPI() {
    return apiGet('/api/getLeaveCalendarAdmin')
}

export function getUpcomingLeavesAPI() {
    return apiGet('/api/getUpcomingLeavesAdmin')
}

export function getMyLeavesAPI() {
    return apiGet('/api/getMyLeavesAdmin')
}

export function cancelLeaveAPI(data) {
    return apiPost('/api/cancelLeaveAdmin', data)
}

export function getBlockedDatesAPI() {
    return apiGet('/api/getBlockedDatesAdmin')
}

export function getPendingLeaveRequestsAPI() {
    return apiGet('/api/getPendingLeaveRequestsAdmin')
}

export function reviewLeaveAPI(data) {
    return apiPost('/api/reviewLeaveAdmin', data)
}
